import { render, staticRenderFns } from "./contnet.vue?vue&type=template&id=2848bc18"
import script from "./contnet.vue?vue&type=script&lang=ts"
export * from "./contnet.vue?vue&type=script&lang=ts"
import style0 from "@/style/index.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports